import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import MainInput from "../../../component/atoms/input/mainInput";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import BasicApi from "../../../api/basic.api";
import { errorHandler } from "../../../util/errorHandler";
import ImgInput from "../../../component/atoms/input/imgInput";
import ImgPreview from "../../../component/molecules/imgPreview";
import { imgUrl } from "../../../constants/url";
import CommonApi from "../../../api/common.api";

const BasicEdit = () => {
  const navigate = useNavigate();
  const [logo, setLogo] = useState({
    file: "",
    fileUrl: "",
    imageOriginFileName: "이미지.jpg",
    imageServerFileName: "이미지.jpg",
    deleteFile: false,
  });
  const [companyName, setCompanyName] = useState("");
  const [ceo, setCeo] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [reportNumber, setReportNumber] = useState("");
  const [address, setAddress] = useState("");
  const [tel, setTel] = useState("");
  const [email, setEmail] = useState("");
  const [csCenter1, setCsCenter1] = useState("");
  const [csCenter2, setCsCenter2] = useState("");
  const [csCenter3, setCsCenter3] = useState("");
  const [membershipPrice, setMembershipPrice] = useState("");

  const getBasicInfo = async () => {
    try {
      let data = (await BasicApi.getBasicInfo()).data.data.content;

      setCompanyName(data.companyName);
      setCeo(data.ceo);
      setBusinessNumber(data.businessNumber);
      setReportNumber(data.reportNumber);
      setAddress(data.address);
      setTel(data.tel);
      setEmail(data.email);
      setCsCenter1(data.csCenter1);
      setCsCenter2(data.csCenter2);
      setCsCenter3(data.csCenter3);
      setMembershipPrice(data.membershipPrice);

      setLogo({
        ...logo,
        imageOriginFileName: data.logoOriginFileName,
        imageServerFileName: data.logoServerFileName,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getBasicInfo();
  }, []);

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (!companyName.trim()) {
      toast("상호명을 입력해주세요.");
      return;
    }
    if (!ceo.trim()) {
      toast("대표자을 입력해주세요.");
      return;
    }
    if (!businessNumber.trim()) {
      toast("사업자등록번호를 입력해주세요.");
      return;
    }
    if (!reportNumber.trim()) {
      toast("통신판매업신고번호를 입력해주세요.");
      return;
    }
    if (!address.trim()) {
      toast("주소를 입력해주세요.");
      return;
    }
    if (!tel.trim()) {
      toast("전화번호를 입력해주세요.");
      return;
    }
    if (!email.trim()) {
      toast("이메일을 입력해주세요.");
      return;
    }
    if (!csCenter1.trim() || !csCenter2.trim() || !csCenter3.trim()) {
      toast("CS CENTER 정보를 모두 입력해주세요.");
      return;
    }
    if (!Number.isFinite(Number(membershipPrice)) || Number(membershipPrice) <= 0) {
      toast("구독 금액은 0보다 크게 입력해주세요.");
      return;
    }
    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        logoOriginFileName: logo.imageOriginFileName,
        logoServerFileName: logo.imageServerFileName,
        companyName,
        ceo,
        businessNumber,
        reportNumber,
        address,
        tel,
        email,
        csCenter1,
        csCenter2,
        csCenter3,
        membershipPrice: Number(membershipPrice),
      };

      if (logo.file) {
        const response = await fileUpload(logo.file);

        data.logoOriginFileName = response.imageOriginFileName;
        data.logoServerFileName = response.imageServerFileName;
      }

      await BasicApi.updateBasicInfo(data);
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.update);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("path", "basic");
      formData.append("file", file);

      const response = (await CommonApi.fileUpload(formData)).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
    }
  };

  const delImg = () => {
    setLogo({
      file: "",
      fileUrl: "",
      imageOriginFileName: "",
      imageServerFileName: "",
      deleteFile: true,
    });
  };

  //이미지 추가, 삭제
  const inputFile = (e) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      setLogo({
        ...logo,
        file: file,
        fileUrl: value.target.result,
      });
    };
    e.target.value = "";
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>기본정보</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {/* 로고 */}
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  로고
                  <br />
                  (120*44px)
                </DetailFormTitle>
                {logo.imageServerFileName || logo.fileUrl ? (
                  <ImgPreview
                    fileUrl={
                      logo.fileUrl
                        ? logo.fileUrl
                        : imgUrl + logo.imageServerFileName
                    }
                    onClick={() => {
                      delImg();
                    }}
                  />
                ) : (
                  <ImgInput
                    id={"file"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e);
                    }}
                  />
                )}
              </DetailPageForm>

              {/* 상호명 */}
              <DetailPageForm>
                <DetailFormTitle>상호명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"상호명을 입력해주세요"}
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </DetailPageForm>

              {/* 대표 */}
              <DetailPageForm>
                <DetailFormTitle>대표*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"대표명을 입력해주세요"}
                  value={ceo}
                  onChange={(e) => setCeo(e.target.value)}
                />
              </DetailPageForm>

              {/* 사업자등록번호 */}
              <DetailPageForm>
                <DetailFormTitle>사업자등록번호*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"사업자등록번호를 입력해주세요"}
                  value={businessNumber}
                  onChange={(e) => setBusinessNumber(e.target.value)}
                />
              </DetailPageForm>

              {/* 통신판매업신고번호*/}
              <DetailPageForm>
                <DetailFormTitle>통신판매업신고번호*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"통신판매업신고번호를 입력해주세요"}
                  value={reportNumber}
                  onChange={(e) => setReportNumber(e.target.value)}
                />
              </DetailPageForm>

              {/* 주소 */}
              <DetailPageForm>
                <DetailFormTitle>주소*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"주소를 입력해주세요"}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </DetailPageForm>

              {/* TEL*/}
              <DetailPageForm>
                <DetailFormTitle>TEL*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"전화번호를 입력해주세요"}
                  value={tel}
                  onChange={(e) => setTel(e.target.value)}
                />
              </DetailPageForm>

              {/* E-MAIL */}
              <DetailPageForm>
                <DetailFormTitle>E-MAIL*</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"이메일을 입력해주세요"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </DetailPageForm>

              {/* CS CENTER */}
              <DetailPageForm>
                <DetailFormTitle>구독 금액*</DetailFormTitle>
                <MainInput
                  style={{ width: 338 }}
                  type={"number"}
                  min={1}
                  placeholder={"구독 금액을 입력해주세요"}
                  value={membershipPrice}
                  onChange={(e) => setMembershipPrice(e.target.value)}
                />
              </DetailPageForm>

              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>CS CENTER*</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <MainInput
                    style={{
                      width: 338,
                    }}
                    type={"text"}
                    placeholder={"00-0000-0000"}
                    value={csCenter1}
                    onChange={(e) => setCsCenter1(e.target.value)}
                  />
                  <MainInput
                    style={{
                      width: 338,
                    }}
                    type={"text"}
                    placeholder={"평일:  09:00 ~ 16:00"}
                    value={csCenter2}
                    onChange={(e) => setCsCenter2(e.target.value)}
                  />
                  <MainInput
                    style={{
                      width: 338,
                    }}
                    type={"text"}
                    placeholder={"토요일, 일요일, 공휴일 휴무"}
                    value={csCenter3}
                    onChange={(e) => setCsCenter3(e.target.value)}
                  />
                </div>
              </DetailPageForm>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler();
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default BasicEdit;
